<template>
    <YpModal
        size="sm"
        :visible="isModalVisible"
        @closed="handleModalAction"
    >
        <div class="text-center">
            <h1 class="text-2xl font-medium mb-2">Nova comissão dos afiliados</h1>
            <p class="text-gray-700 mb-6">Ajustamos nossas regras para focar em crescimento real e recompensar indicações de qualidade.</p>
            <div class="flex flex-col gap-2 text-sm text-left">
                <div class="flex gap-3 items-start p-3 rounded-md bg-gray-50 border border-gray-200">
                    <span class="shrink-0 font-semibold text-gray-700 w-12 text-right leading-snug">Antes</span>
                    <span class="text-gray-600 leading-snug">R$ 50,00 liberados assim que o lojista realizava qualquer pagamento à Yampi.</span>
                </div>
                <div class="flex gap-3 items-start p-3 rounded-md bg-green-50 border border-green-200">
                    <span class="shrink-0 font-semibold text-green-700 w-12 text-right leading-snug">Agora</span>
                    <span class="text-green-600 leading-snug">R$ 50,00 liberados após o lojista acumular, no mínimo, <strong>R$ 100,00</strong> em pagamentos.</span>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="w-full flex gap-4">
                <YpButton
                    class="flex-1"
                    variant="secondary"
                    text="Fechar"
                    @click.prevent="handleModalAction()"
                />
                <YpButton
                    class="flex-1"
                    text="Ver novas regras"
                    @click.prevent="handleModalAction(true)"
                    iconPos="right"
                    icon="yp yp-arrow-up-right-from-square"
                />
            </div>
        </template>
    </YpModal>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import YpModal from '@/components/core/YpModal.vue';
import YpButton from '@/components/core/YpButton.vue';

const store = useStore();
const props = defineProps({
    visible: { type: Boolean, default: true },
});

const emit = defineEmits(['closed', 'success']);

// Closed modal actions
const isModalVisible = ref(props.visible);

const handleModalAction = (openLink = false) => {
    if (openLink) {
        window.open('https://help.yampi.com.br/pt-BR/articles/6067734-qual-o-valor-da-comissao-do-programa-de-afiliados', '_blank');
    }
    store.dispatch('featureModal/hideModal', 'affiliateRules');
    emit('closed');
};

watch(
    () => props.visible,
    (newVal) => {
        isModalVisible.value = newVal;
    },
);
</script>
